// extracted by mini-css-extract-plugin
export var sliderRange = "_qa-2";
export var sliderRoot = "_qa-0";
export var sliderThumb = "_qa-3";
export var sliderTrack = "_qa-1";